import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';
import { px2rem } from '@/theme';

import { ReactComponent as RulerIcon } from '@/assets/ruler.svg';

export const Wrapper = styled(Flex)`
  align-items: center;

  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(2)};

    ${theme.media.md.down} {
      justify-content: center;
    }
  `}
`;

export const Text = styled(Typography)`
  ${({ theme }) => css`
    margin-right: ${theme.spacing(1)};

    ${theme.media.md.up} {
      margin-right: ${theme.spacing(2)};
    }
  `}
`;

export const SelectWrapper = styled(Box)`
  max-width: 130px;
  line-height: 100%;
`;

export const SizeGuide = styled(Box)`
  text-transform: uppercase;
  text-decoration: underline;
  display: inline-flex;
  align-items: center;
  text-underline-offset: 4px;

  ${({ theme }) => css`
    text-decoration-color: ${theme.colors.primary};
    font-size: ${theme.fontSizes.p2};
    font-weight: ${theme.fontWeights.bold};
    color: ${theme.colors.primaryBlue};
  `}
`;

export const Ruler = styled(RulerIcon)`
  width: ${px2rem(20)};
  margin-inline: ${px2rem(10)};

  &:hover {
    cursor: pointer;
  }

  ${({ theme }) => css`
    color: ${theme.colors.secondaryGrey};
    ${theme.media.md.up} {
      margin-left: ${px2rem(18)};
    }
  `}
`;
